import { Controller } from '@hotwired/stimulus';

// Connects to data-controller="sidebar"
export default class extends Controller {
  connect() {
    this.toggleButton = document.getElementById('filterButton');
    if (!this.toggleButton) return;

    this.boundToggle = this.toggleSidebar.bind(this);
    this.toggleButton.addEventListener('click', this.boundToggle);
  }

  disconnect() {
    if (this.toggleButton && this.boundToggle) {
      this.toggleButton.removeEventListener('click', this.boundToggle);
    }
  }

  toggleSidebar() {
    this.element.classList.toggle('hidden');
  }
}
